'use strict';

module.exports = '2.8.1';



/*****************
 ** WEBPACK FOOTER
 ** ./~/algoliasearch-helper/src/version.js
 ** module id = 210
 ** module chunks = 0
 **/